import * as c from '../constants';
import { FETCH_ESHOP_HEADER_DATA_SUCCESS, IS_ESHOP_NAVANDSEARCH, FETCH_ESHOP_HEADER_DATA_ERROR, IS_NOT_CANOPY, SET_ESHOP_KW, LOAD_NOT_SELLER_ESHOP_HEADER, } from '../actionTypes';
export function reducer(state = c.DEFAULT_STATE, action) {
    switch (action.type) {
        case FETCH_ESHOP_HEADER_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), action.payload);
        case FETCH_ESHOP_HEADER_DATA_ERROR:
            return Object.assign(Object.assign({}, state), action.payload);
        case IS_ESHOP_NAVANDSEARCH:
            return Object.assign(Object.assign({}, state), action.payload);
        case IS_NOT_CANOPY:
            return Object.assign(Object.assign({}, state), action.payload);
        case SET_ESHOP_KW:
            return Object.assign(Object.assign({}, state), action.payload);
        case LOAD_NOT_SELLER_ESHOP_HEADER:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
}
